import { useEffect, useState } from "react";
import { getGenericRQScoringConfigBackupByQuery } from "../services/scoringService";

const useFetchGenericRQScoringConfigBackup = ({
  queryId,
  setIsLoading,
  page,
  pSize,
}: any) => {
  const [backupData, setBackupData] = useState<any>([]);

  useEffect(() => {
    if (queryId && queryId > 0) {
      setIsLoading(true);
      const fetchData = async () => {
        try {
          const result = await getGenericRQScoringConfigBackupByQuery({
            queryId,
            page,
            pSize,
          });
          setBackupData(result);
        } catch (err) {
          setBackupData([]);
        } finally {
          setIsLoading(false);
        }
      };
      fetchData();
    }
  }, [queryId, page, pSize]);

  return [backupData];
};

export default useFetchGenericRQScoringConfigBackup;

